/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Email_InvalidInputs */

const es_ab_err_email_invalid = /** @type {(inputs: Ab_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un email válido`)
};

const gl_ab_err_email_invalid = /** @type {(inputs: Ab_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un email válido`)
};

const en_ab_err_email_invalid = /** @type {(inputs: Ab_Err_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email" |
*
* @param {Ab_Err_Email_InvalidInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_email_invalid = /** @type {((inputs?: Ab_Err_Email_InvalidInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Email_InvalidInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_email_invalid(inputs)
	if (locale === "en") return en_ab_err_email_invalid(inputs)
	return es_ab_err_email_invalid(inputs)
});